import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {isOk} from "../../utils/apiResponse";
import { withTranslation } from 'react-i18next';

class BusinessUnitHeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name,
            status: this.props.status,
            clientId: this.props.clientId,
            clientName: this.props.clientName,
            campaignChannel: this.props.campaignChannel,
            campaignChannelForDisplay: this.props.campaignChannelForDisplay,
        }
    }

    componentDidMount() {
        this.getBusinessUnitData();
    }

    editBusinessUnitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/edit`;
    }

    getBusinessUnitData() {
        if (this.state.name === undefined) {
            new APIClient(this.editBusinessUnitUrl()).call('GET').then((response) => {
                // Familia FRONTEND-47. Preguntaba por `status === 'ERROR'` (con alert() en un camino
                // de CARGA) y seteaba sólo con `=== 'OK'`, asi que un NETWORK_ERROR no entraba por
                // ninguna rama: `status` se quedaba en `undefined` y `renderStatus()` caia al else,
                // que imprime «inactivo» sobre una linea ACTIVA. No se colgaba: mentia.
                // Ahora, si no se pudo traer, el encabezado no afirma NADA (ver `hasData`).
                if (!isOk(response)) {
                    return;
                }
                this.setState({
                    name: response.data.name,
                    status: response.data.status,
                    clientId: response.data.client_id,
                    clientName: response.data.client_name,
                    campaignChannel: response.data.campaign_channel,
                    campaignChannelForDisplay: response.data.campaign_channel_for_display,
                });
                // Opcional: la pantalla que necesita el cliente de la línea lo toma de acá en vez de
                // volver a pedir `edit` (la configuración de alertas, para «Quién recibe»).
                if (this.props.onLoaded) this.props.onLoaded(response.data);
            });
        }
    }

    /**
     * Si el fetch no respondio no hay nada que decir del estado ni del canal, y callarse es lo unico
     * honesto: «Tipo:» y «Estado:» vacios son rotulos huerfanos, y «inactivo» es directamente falso.
     */
    hasData() {
        return this.state.status !== undefined && this.state.status !== null;
    }

    renderStatus() {
        const { t } = this.props;
        if (this.state.status === 'active') {
            return t('business_unit_header.status_active')
        }
        else {
            return t('business_unit_header.status_inactive')
        }
    }

    render() {
        const { t } = this.props;
        let channelClass = 'facebook';
        if (this.state.campaignChannel === 'GOOGLE') {
            channelClass = 'google';
        }

        return (
            <header className="section-header">
                <div className="section-info">
                    <Link className="section-title-button" to={`/client/${this.state.clientId}`}>
                        {this.state.clientName}
                    </Link>
                    <h1 className="section-title">{this.state.name ? `| ${this.state.name}` : ''}</h1>
                    {this.hasData() &&
                        <div className="section-detail">
                            <p className="label">{t('business_unit_header.type')}</p>
                            <p className={`channel -${channelClass}`}>
                                {this.state.campaignChannelForDisplay}
                            </p>
                        </div>}
                    {this.hasData() &&
                        <div className="section-detail">
                            <p className="label">{t('business_unit_header.status')}</p>
                            <p className={`status -${this.state.status}`}>
                                {this.renderStatus()}
                            </p>
                        </div>}
                </div>
                <div className="header-dashboard">
                    {/*<button className="btn -action">Pause</button>*/}
                    {/*<button className="btn -action">Delete</button>*/}
                </div>
            </header>
        )
    }
}

export const BusinessUnitHeader = withTranslation()(BusinessUnitHeaderComponent);
